import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { RawSkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const ButtonLinkLoaderBase = /*#__PURE__*/styled('div')({
  name: "ButtonLinkLoaderBase",
  class: "b14p139h",
  propsAsIs: false
});
const underlinedButtonStyles = "u1swbce7";
export const ButtonLinkLoader = () => <ButtonLinkLoaderBase className={cx(underlinedButtonStyles)}>
    <RawSkeletonLoader width={135} />
  </ButtonLinkLoaderBase>;

require("./ButtonLink.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ButtonLink.tsx");